export default "__VITE_ASSET__81ba83e7__"